module.exports = __webpack_public_path__ + "static/media/sample-activity-report-eur.a4f7c37f.pdf";